var React = require('react');

function Child (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M120 72a72 72 0 1 1 72 72 72 72 0 0 1-72-72z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M9.37 118.63a32 32 0 0 1 45.26-45.26L141.25 160h101.5l86.62-86.63a32 32 0 0 1 45.26 45.26L280 213.25V480a32 32 0 0 1-32 32h-16a32 32 0 0 1-32-32V368h-16v112a32 32 0 0 1-32 32h-16a32 32 0 0 1-32-32V213.25z","className":"fa-primary","key":2})]);
}

Child.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Child;

Child.default = Child;
